export default __webpack_public_path__ + "static/media/flag_arg.b864ecb8.png";